import * as action from './actions/creators';
import * as api from './api';
import { getLocalizedFacilityContent } from '../localization/localization-api';

import * as MsgBarActions from '../system-shared/message-bar-action-creator';

export const loadContactInstructions = (facilityId, languageCode) => (dispatch) =>
  getLocalizedFacilityContent('ContactUsHeading', facilityId, languageCode)
    .then(
      (response) => {
        dispatch(action.contactInstructionsLoaded(response.data));
      },
      () => {
        dispatch(MsgBarActions.showErrorMessage('noInstructionsInContactUs'));
        dispatch(action.contactInstructionsLoadFailed());
      }
    );

export const loadContacts = (facilityId) => (dispatch) =>
  api.getContacts(facilityId)
    .then(
      (response) => {
        dispatch(action.contactsLoaded(response.data));
      },
      () => {
        dispatch(MsgBarActions.showErrorMessage('noContactsInContactUs'));
        dispatch(action.contactsLoadFailed());
      }
    );
